module.exports = __webpack_public_path__ + "img/2026-02.0c0ae44e.jpg";